import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Alert } from '@mui/material';
import { AppContext } from '../../../sporttia/all';

export default function BookingSectionMessages({ bookingPrivilege, sc }: any) {
    const cxt = useContext(AppContext)!;
    const { t } = useTranslation();

    return (
        <Box mt={2}>
            {cxt.logged && !bookingPrivilege && (
                <Alert severity="warning">{t('booking.noRentPrivilege')}</Alert>
            )}

            {!sc.modules.includes('booking') && (
                <Alert severity="warning">{t('booking.scNoBookingMod')}</Alert>
            )}

            {!cxt.logged && (
                <Alert severity="warning">{t('booking.mustLogin')}</Alert>
            )}
        </Box>
    );
}
